export default __webpack_public_path__ + "static/media/7003550c39713595.e0f5a32ddcbced3a4465447606b5e748.svg";